'use client';

import type {
  CreateProductLinkServiceRequest,
  CreateProductLinkServiceResponse,
} from '@musinsa/services-curator';
import { createProductLinkService } from '@musinsa/services-curator';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';

export const useCreateProductLink = (): UseMutationResult<
  CreateProductLinkServiceResponse,
  Error,
  CreateProductLinkServiceRequest
> =>
  useMutation<CreateProductLinkServiceResponse, Error, CreateProductLinkServiceRequest>({
    mutationFn: (request: CreateProductLinkServiceRequest) => createProductLinkService(request),
  });
